export const CenterProjectionType = {
  INSIDE_BOUNDS: 0,
  IGNORE_BOUNDS: 1,
  FIT_BOUNDS: 2,
};

export default {
  CenterProjectionType,
};
